import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';

var Warehouse = function Warehouse(_ref) {
  var isActive = _ref.isActive;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "13",
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    // eslint-disable-next-line
    d: "M15.5284 4.92859L13.2644 2.66459C12.9684 2.36859 12.5604 2.20059 12.1364 2.20059H5.6004V1.40059C5.6004 0.960586 5.2404 0.600586 4.8004 0.600586C4.3604 0.600586 4.0004 0.960586 4.0004 1.40059V2.20059H3.8644C3.4404 2.20059 3.0324 2.36859 2.7284 2.67259L0.472397 4.92859C0.168397 5.23259 0.000396729 5.64059 0.000396729 6.06459V11.0006C0.000396729 11.8806 0.720397 12.6006 1.6004 12.6006H14.4004C15.2804 12.6006 16.0004 11.8806 16.0004 11.0006V6.06459C16.0004 5.64059 15.8324 5.23259 15.5284 4.92859ZM9.6004 11.0006H1.6004V7.00059H9.6004V11.0006ZM14.4004 11.0006H11.2004V6.06459L12.8004 4.46459L14.4004 6.06459V11.0006Z",
    fill: isActive ? '#028EFF' : '#04070C'
  }));
};

var Marker = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 100%;\n  border: 2px solid ", ";\n  box-shadow: 0 0 3px ", ";\n  background-color: white;\n  padding: 3px;\n  z-index: 4;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: box-shadow 1s;\n  &:hover {\n    box-shadow: 0 0 7px #04070C;\n  }\n  height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.isActive ? '#028EFF' : '#04070C';
}, function (props) {
  return props.isActive ? '#028EFF' : '#04070C';
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

var WarehouseMarker = function WarehouseMarker(_ref2) {
  var data = _ref2.data,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '30px' : _ref2$height,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '30px' : _ref2$width,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? false : _ref2$isActive,
      _ref2$onClick = _ref2.onClick,
      _onClick = _ref2$onClick === void 0 ? function (e) {
    return e;
  } : _ref2$onClick,
      _ref2$onBlur = _ref2.onBlur,
      onBlur = _ref2$onBlur === void 0 ? function (e) {
    return e;
  } : _ref2$onBlur,
      _ref2$onMouseOver = _ref2.onMouseOver,
      onMouseOver = _ref2$onMouseOver === void 0 ? function (e) {
    return e;
  } : _ref2$onMouseOver,
      _ref2$onMouseOut = _ref2.onMouseOut,
      onMouseOut = _ref2$onMouseOut === void 0 ? function (e) {
    return e;
  } : _ref2$onMouseOut;

  return /*#__PURE__*/React.createElement(Marker, {
    height: height,
    width: width,
    isActive: isActive,
    onClick: function onClick() {
      return _onClick(data);
    },
    onBlur: onBlur,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, /*#__PURE__*/React.createElement(Warehouse, {
    isActive: isActive
  }));
};

export default WarehouseMarker;